import { createActionTypes } from 'utils/action/actionTypes';

export const FETCH_VEHICLE_MODEL = createActionTypes('FETCH_VEHICLE_MODEL');
export const GET_VEHICLE_MODEL = createActionTypes('GET_VEHICLE_MODEL_MAKE');
export const CREATE_VEHICLE_MODEL = createActionTypes('CREATE_VEHICLE_MODEL');
export const UPDATE_VEHICLE_MODEL = createActionTypes('UPDATE_VEHICLE_MODEL');
export const DELETE_VEHICLE_MODEL = createActionTypes('DELETE_VEHICLE_MODEL');
